'use client';
import Carousel from '@components/Carousel/Carousel';
import ImageWrapper from '@components/Image';
import clsx from 'clsx';
import React from 'react';
import { VSCMultimedia } from 'types/vsc_atdwapi';

export interface MediaCarouselProps {
  items: VSCMultimedia[];
  className?: string;
}

export const AtdwCarousel: React.FC<MediaCarouselProps> = ({
  items,
  className,
}) => {
  const MediaCarouselClasses = clsx(
    'w-full !overflow-hidden md:order-none rounded-xl aspect-video md:aspect-imax bg-gray-200',
    'relative',
    className
  );

  if (!items) {
    return <div className="aspect-video md:aspect-imax"></div>;
  }

  const slides = items
    .map((item, index) => {
      if (item?.serverPath?.includes('assets.atdw')) {
        return (
          <div
            className="relative aspect-imax w-full overflow-hidden"
            key={`${index}-${item?.multimediaId}`}>
            <ImageWrapper
              itemProp
              src={item.serverPath}
              alt={item.altText}
              cover
              fullWidth
              fullHeight
              priority
              dimensions={{
                width: 1680,
                height: 1200,
              }}
              className="bg-gray-200"
              imgClassName="aspect-imax"
            />
          </div>
        );
      } else {
        return null;
      }
    })
    .filter((slide) => slide !== null);

  return (
    <div className={MediaCarouselClasses}>
      <Carousel items={slides} hero pagination={false} />
    </div>
  );
};

export default AtdwCarousel;
